<app-navbar></app-navbar>
<section class="remove-padding relative view-height-100vh white-bg" id="home">
    <div class="parallax-overlay"></div>
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-sm-12 col-xs-12 display-table view-height-100vh">
                <div class="v-align-middle text-center">
                    <div class="white-color text-center">
          <h1 class="hero-title font-oswald">O laboratório dos <span class="highlight">Criadores de Impacto</span></h1>
          <h4 class="hero-subtitle font-inter">Aqui você cria! A gente eleva.</h4>
                        <p class="mt-30">
                            <a class="btn btn-lg btn-light btn-circle">contato</a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <video #bgVideo autoplay playsinline loop muted class="html5-video">
  <source src="assets/videos/explore.mp4" type="video/mp4" />
</video>
</section>
<!-- Estúdio A - Mesa Cast -->
<section id="studios" class="studio-produtora">
  <div class="studio-produtora-container">
    <h2 class="studio-produtora-title">ESTÚDIO <span class="studio-produtora-accent">MESACAST</span></h2>
    
    <div class="studio-intro-text">
      <h3>Um espaço <span class="studio-produtora-accent">premium</span> no coração de Montes Claros</h3>
      <p>
        Projetado para criadores exigentes, nosso estúdio entrega excelência técnica e flexibilidade total.  
        Ideal para podcasts, mesacasts, videoaulas e transmissões ao vivo, garantimos produção com padrão profissional e acabamento de alto nível.
      </p>
    </div>

    <div class="studio-produtora-grid">
      <!-- Galeria de Imagens (Carrossel) -->
      <div class="studio-carousel-container">
        <div class="mb-4">
          <img [src]="currentImageStudioA" alt="Visão geral do Estúdio A" class="studio-produtora-main-img">
        </div>
        <button (click)="nextImageStudioA()" class="carousel-button prev">
          <i-lucide [img]="ChevronLeftIcon" class="my-icon"></i-lucide>
        </button>
        <button (click)="prevImageStudioA()" class="carousel-button next">
          <i-lucide [img]="ChevronRightIcon" class="my-icon"></i-lucide>
        </button>
        <div class="carousel-dots">
          <span *ngFor="let image of studioAImages; let i = index"
                class="carousel-dot"
                [class.active]="i === currentImageIndexStudioA"
                (click)="goToSlideStudioA(i)">
          </span>
        </div>
      </div>

      <!-- Descrição do Estúdio -->
      <div class="studio-produtora-description">
        <ul>
          <li>
            <i-lucide [img]="Sun" class="my-icon"></i-lucide>
            <span><strong class="studio-produtora-accent">Iluminação cinematográfica:</strong> Luzes personalizáveis para criar atmosferas únicas, alinhando o cenário à sua identidade visual.</span>
          </li>
          <li>
            <i-lucide [img]="CameraVideo" class="my-icon"></i-lucide>
            <span><strong class="studio-produtora-accent">Imagem 4K profissional:</strong> Equipado com câmeras Sony 4K para máxima nitidez e qualidade digna dos grandes estúdios.</span>
          </li>
          <li>
            <i-lucide [img]="Mic" class="my-icon"></i-lucide>
            <span><strong class="studio-produtora-accent">Áudio cristalino:</strong> Microfones Shure SM7B para captação clara e potente, referência mundial em estúdios.</span>
          </li>
          <li>
            <i-lucide [img]="Broadcast" class="my-icon"></i-lucide>
            <span><strong class="studio-produtora-accent">Produção e streaming integrados:</strong> Mesa ATEM Mini ISO Pro para cortes precisos, gravações multicâmera e transmissões ao vivo impecáveis.</span>
          </li>
          <li>
            <i-lucide [img]="LayoutDashboard" class="my-icon"></i-lucide>
            <span><strong class="studio-produtora-accent">Cenário customizado:</strong> Ambiente versátil adaptável à sua marca, com cores, logos e gráficos exclusivos.</span>
          </li>
          <li>
            <i-lucide [img]="Monitor" class="my-icon"></i-lucide>
            <span><strong class="studio-produtora-accent">Mídia central 4K:</strong> TV Samsung "The Frame" 55” integrada para exibir conteúdos com elegância e alta definição.</span>
          </li>
          <li>
            <i-lucide [img]="HardDriveDownload" class="my-icon"></i-lucide>
            <span><strong class="studio-produtora-accent">Redundância sonora:</strong> Gravação simultânea em múltiplas fontes via interfaces RME, garantindo total segurança do conteúdo.</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</section>


<!-- Estúdio B - Estúdio Música (layout invertido com carrossel) -->
<section id="studio-b" class="studio-produtora">
  <div class="studio-produtora-container">
    <h2 class="studio-produtora-title">ESTÚDIO <span class="studio-produtora-accent">MÚSICA</span></h2>
    
    <div class="studio-intro-text">
      <h3>Um estúdio com <span class="studio-produtora-accent">excelência sonora e visual</span></h3>
      <p>
        Ambiente tratado acusticamente e visualmente premium, equipado com tecnologia de ponta para gravações, videoclipes e performances ao vivo de alto padrão.
      </p>
    </div>

    <div class="studio-produtora-grid">
      <!-- Descrição técnica -->
      <div class="studio-produtora-description">
        <ul>
          <li>
            <i-lucide [img]="PaletteIcon" class="my-icon"></i-lucide>
            <span><strong class="studio-produtora-accent">Ciclorama motorizado:</strong> Fundo infinito com acionamento automático, disponível em verde e outras cores para chroma key ou identidade visual.</span>
          </li>
          <li>
            <i-lucide [img]="LayoutIcon" class="my-icon"></i-lucide>
            <span><strong class="studio-produtora-accent">Design com ripado premium:</strong> Parede ripada iluminada para ambiente moderno, ideal para vídeo e entrevistas musicais.</span>
          </li>
          <li>
            <i-lucide [img]="Volume2Icon" class="my-icon"></i-lucide>
            <span><strong class="studio-produtora-accent">Acústica profissional:</strong> Tratamento com painéis absorventes e difusores para resposta sonora precisa em gravações e mixagens.</span>
          </li>
          <li>
            <i-lucide [img]="MicIcon" class="my-icon"></i-lucide>
            <span><strong class="studio-produtora-accent">Microfones premium:</strong> Neumann U87, TLM103, KM184, Shure SM7B, SM57, Beta58, MD421, Audix DP7 e outros para máxima versatilidade.</span>
          </li>
          <li>
            <i-lucide [img]="SettingsIcon" class="my-icon"></i-lucide>
            <span><strong class="studio-produtora-accent">Interfaces e periféricos de referência:</strong> Metric Halo ULN-2, 2882, RME UFX, monitores Yamaha NS10 e MSP5, Avalon, pré-amps estilo Neve, pedais Fractal, Tonex e processadores analógicos.</span>
          </li>

          <li>
            <i-lucide [img]="DrumstickIcon" class="my-icon"></i-lucide>
            <span><strong class="studio-produtora-accent">Instrumentos no local:</strong> Bateria Pearl, amplificadores Marshall e outros para gravações e performances ao vivo.</span>
          </li>
        </ul>
      </div>

      <!-- Galeria / Carrossel -->
      <div class="studio-carousel-container">
        <div class="mb-4">
          <img [src]="currentImageStudioB" alt="Visão geral do Estúdio B" class="studio-produtora-main-img">
        </div>

        <button (click)="prevImageStudioB()" class="carousel-button prev">
          <i-lucide [img]="ChevronLeftIcon"></i-lucide>
        </button>
        <button (click)="nextImageStudioB()" class="carousel-button next">
          <i-lucide [img]="ChevronRightIcon"></i-lucide>
        </button>

        <div class="carousel-dots">
          <span *ngFor="let image of studioBImages; let i = index"
                class="carousel-dot"
                [class.active]="i === currentImageIndexStudioB"
                (click)="goToSlideStudioB(i)">
          </span>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Sala de Mixagem de Alto Padrão (layout invertido) -->
<section id="studio-c" class="studio-produtora">
  <div class="studio-produtora-container">
    <h2 class="studio-produtora-title">SALA DE <span class="studio-produtora-accent">MIXAGEM E EDIÇÃO DE VÍDEO</span></h2>

    <div class="studio-intro-text">
      <h3>Mixagem e masterização em ambiente <span class="studio-produtora-accent">controlado e sofisticado</span></h3>
      <p>
        Espaço dedicado com acústica otimizada para pós-produção de áudio, equipado com monitores de referência e equipamentos de última geração que garantem precisão sonora incomparável.
      </p>
    </div>

    <div class="studio-produtora-grid">
      <div class="studio-produtora-description">
        <ul>
            <li>
            <i-lucide [img]="CpuIcon" class="my-icon"></i-lucide>
            <span><strong class="studio-produtora-accent">Software profissional:</strong> Pro Tools Studio 2025.6, última versão para total estabilidade e compatibilidade no mercado musical.</span>
          </li>
          <li>
            <i-lucide [img]="Monitor" class="my-icon"></i-lucide>
            <span><strong class="studio-produtora-accent">Monitores de referência:</strong> Yamaha NS10, MSP5 e outras marcas de ponta para audição crítica e detalhada.</span>
          </li>
          <li>
            <i-lucide [img]="SettingsIcon" class="my-icon"></i-lucide>
            <span><strong class="studio-produtora-accent">Equipamentos analógicos e digitais:</strong> Consoles Yamaha, processadores Avalon, Fractal, Neve, Art MPA Gold, e plugins que aliam o melhor dos dois mundos para mixagens precisas.</span>
          </li>
          <li>
            <i-lucide [img]="CpuIcon" class="my-icon"></i-lucide>
            <span><strong class="studio-produtora-accent">Software edição:</strong> Davince Resolve Stúdio 20 e ferramentas de masterização para um acabamento perfeito em cada projeto.</span>
          </li>
          <li>
            <i-lucide [img]="FileIcon" class="my-icon"></i-lucide>
            <span><strong class="studio-produtora-accent">Fluxo otimizado:</strong> Integração fluida entre gravação, edição, mixagem e masterização, garantindo máxima produtividade e qualidade.</span>
          </li>
                    <li>
            <i-lucide [img]="CpuIcon" class="my-icon"></i-lucide>
            <span><strong class="studio-produtora-accent">Workstation:</strong> Computadores de ultima geração Apple/Windows garantindo segurança nas gravações.</span>
          </li>
        </ul>
      </div>

      <div class="studio-carousel-container">
        <div class="mb-4">
          <img [src]="currentImageStudioC" alt="Visão geral da Sala de Mixagem" class="studio-produtora-main-img">
        </div>

        <button (click)="prevImageStudioC()" class="carousel-button prev">
          <i-lucide [img]="ChevronLeftIcon"></i-lucide>
        </button>
        <button (click)="nextImageStudioC()" class="carousel-button next">
          <i-lucide [img]="ChevronRightIcon"></i-lucide>
        </button>

        <div class="carousel-dots">
          <span *ngFor="let image of studioCImages; let i = index"
                class="carousel-dot"
                [class.active]="i === currentImageIndexStudioC"
                (click)="goToSlideStudioC(i)">
          </span>
        </div>
      </div>
    </div>
  </div>
</section>

<section id="services" class="services-produtora">
  <div class="services-produtora-container">
    
    <!-- Texto de Introdução -->
    <div class="services-produtora-intro">
      <h2 class="font-oswald">Nossas <span class="studio-produtora-accent">Soluções Criativas</span></h2>
      <p class="font-inter">
        Combinamos tecnologia de ponta e uma visão artística para transformar ideias em conteúdo audiovisual que cativa, envolve e gera resultados.
      </p>
    </div>

    <!-- Grelha de Serviços -->
    <div class="services-produtora-grid">

      <!-- Produção de Vídeo -->
      <div class="service-card">
        <div class="service-card-icon">
          <i-lucide [img]="CameraVideo"></i-lucide>
        </div>
        <h3 class="service-card-title">Produção de Vídeo</h3>
        <p class="service-card-description">
          De vídeos institucionais a campanhas para redes sociais, entregamos qualidade cinematográfica com narrativa impactante.
        </p>
      </div>

      <!-- Podcasts & Mesacasts -->
      <div class="service-card">
        <div class="service-card-icon">
          <i-lucide [img]="MicIcon"></i-lucide>
        </div>
        <h3 class="service-card-title">Podcasts & Mesacasts</h3>
        <p class="service-card-description">
          Gravação em estúdio equipado com o melhor da tecnologia de som e imagem. Qualidade de voz e imagem que eleva sua mensagem.
        </p>
      </div>

      <!-- Transmissões Ao Vivo -->
      <div class="service-card">
        <div class="service-card-icon">
          <i-lucide [img]="Broadcast"></i-lucide>
        </div>
        <h3 class="service-card-title">Transmissões Ao Vivo</h3>
        <p class="service-card-description">
          Eventos, aulas e lançamentos com multicâmeras e transmissão estável via mesa ATEM Pro. Alcance sua audiência em tempo real.
        </p>
      </div>

      <!-- Produção Musical -->
      <div class="service-card">
        <div class="service-card-icon">
          <i-lucide [img]="music"></i-lucide>
        </div>
        <h3 class="service-card-title">Produção & Gravação Musical</h3>
        <p class="service-card-description">
          Gravação vocal e instrumental com microfones lendários, interfaces profissionais e ambientes tratados acusticamente.
        </p>
      </div>

      <!-- Pós-Produção -->
      <div class="service-card">
        <div class="service-card-icon">
          <i-lucide [img]="SettingsIcon"></i-lucide>
        </div>
        <h3 class="service-card-title">Pós-Produção de Elite</h3>
        <p class="service-card-description">
          Montagem, color grading, motion graphics e sound design. Finalizamos seu projeto com um acabamento digno das telas grandes.
        </p>
      </div>

      <!-- Co-produção Artística -->
      <div class="service-card">
        <div class="service-card-icon">
          <i-lucide [img]="PaletteIcon"></i-lucide>
        </div>
        <h3 class="service-card-title">Co-produção Artística</h3>
        <p class="service-card-description">
          Auxiliamos desde a concepção até a execução do seu projeto, colaborando criativamente com roteiro, direção, trilha e identidade audiovisual.
        </p>
      </div>

    </div>
  </div>
</section>


<section id="team" class="team-produtora">
  <div class="team-produtora-container">

    <!-- Cabeçalho -->
    <div class="team-header">
      <h2 class="team-subtitle">Conheça nossa equipe</h2>
      <h1 class="team-title">Nosso Time Criativo</h1>
      <p class="team-description">
        Na EL REY LABS, reunimos especialistas com vasta experiência em produção criativa e soluções tecnológicas. Combinamos criatividade, inovação e conhecimento técnico para entregar projetos que superam expectativas, sempre com foco em qualidade e transformação.
      </p>
    </div>

    <!-- Grid da Equipe -->
    <div class="team-grid">
      <div class="team-card" *ngFor="let slide of slideStoreTwo">
        <div class="team-image">
          <img [src]="'assets/images/team/' + slide.image" [alt]="slide.title">
          <div class="team-overlay">
            <div class="team-info">
              <h3>{{ slide.subtitle }}</h3>
              <span class="team-role">{{ slide.title }}</span>
              <ul class="team-social">
                <li *ngFor="let social of socialLinks">
                  <a href="#" [ngClass]="social.iconOuter">
                    <i [ngClass]="social.iconInner"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</section>


<!-- Video Popup -->
<div class="video-popup" *ngIf="isOpen">
    <div class="popup-inner">
        <iframe width="560" height="315" src="https://www.youtube.com/embed/sU3FkzUKHXU?si=vhtmR7XG-9HXU6Ij" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        <button (click)="closePopup()" type="button" class="close-btn">
            <i class='icofont icofont-close'></i>
        </button>
    </div>
</div>
<section id="portfolio" class="portfolio-produtora">
  <div class="portfolio-produtora-container">
    
    <!-- Cabeçalho -->
    <div class="portfolio-produtora-header">
      <h2 class="portfolio-subtitle">Explore alguns de nossos Projetos</h2>
      <h1 class="portfolio-title">Nosso Portfólio Inspirador</h1>
      <p class="portfolio-description">
        Conheça alguns de nossos projetos que unem criatividade e excelência. Inspire-se com soluções que transformam ideias em experiências visuais únicas!
      </p>
    </div>

    <!-- Grade de Projetos -->
    <div class="portfolio-grid">
      <div *ngFor="let portfolio of portfolios" class="portfolio-item">
        <div class="portfolio-thumb">
          <img [src]="'assets/images/portfolio/grid/' + portfolio.img" [alt]="portfolio.title">
          <div class="portfolio-overlay">
            <div class="portfolio-text">
              <h3>{{ portfolio.title }}</h3>
              <p>{{ portfolio.subTitle }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</section>





<section class="contact-section text-light">
  <div class="container">
    <div class="row">
      <div class="col-md-8 centerize-col text-center">
        <div class="section-title">
          <h2 class="raleway-font" style="color: #f59e0b;">Vamos Conversar</h2>
          <h1 class="raleway-font" style="color: #ffffff;">Fale com a EL REY LABS</h1>
        </div>
        <p style="color: #cbd5e1;">
          Estamos prontos para dar vida às suas ideias com criatividade, qualidade de cinema e uma estrutura digna dos maiores estúdios do Brasil.
        </p>
      </div>
    </div>

    <div class="row mt-5">
      <div class="col-md-6">
        <div class="contact-info-box">
          <div class="info-item">
            <h4 class="info-title"><i class="fa fa-map-marker-alt"></i> Endereço</h4>
            <p>R. Pires e Albuquerque, 64 – Centro<br>Montes Claros – MG</p>
          </div>
          <div class="info-item">
            <h4 class="info-title"><i class="fa fa-phone-alt"></i> Telefone</h4>
            <p>WhatsApp: (38) 99841-3096</p>
          </div>
          <div class="info-item">
            <h4 class="info-title"><i class="fa fa-envelope"></i> E-mail</h4>
            <p>{{email}}</p>
          </div>
          <div class="info-item">
            <h4 class="info-title"><i class="fa fa-headset"></i> Suporte Rápido</h4>
            <p>{{email}}</p>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <form (submit)="sendEmail($event)" class="contact-form-style-01" #contactForm="ngForm">
          <div class="form-group mb-3">
            <label for="user_name" class="text-light">Nome *</label>
            <input type="text" class="md-input" name="user_name" id="user_name"
              [(ngModel)]="formData.user_name" #userName="ngModel" required minlength="2" maxlength="15"
              [class.is-invalid]="userName.invalid && userName.touched" placeholder="Seu nome">
            <div *ngIf="userName.invalid && userName.touched" class="invalid-feedback">Nome é obrigatório.</div>
          </div>

          <div class="form-group mb-3">
            <label for="user_email" class="text-light">Email *</label>
            <input type="email" class="md-input" name="user_email" id="user_email"
              [(ngModel)]="formData.user_email" #userEmail="ngModel" required maxlength="35"
              [class.is-invalid]="userEmail.invalid && userEmail.touched" placeholder="Seu email">
            <div *ngIf="userEmail.invalid && userEmail.touched" class="invalid-feedback">Um email válido é obrigatório.</div>
          </div>

          <div class="form-group mb-3">
            <label for="message" class="text-light">Detalhes do Projeto</label>
            <textarea name="message" class="md-textarea" id="message" rows="6"
              [(ngModel)]="formData.message" #userMessage="ngModel" required
              [class.is-invalid]="userMessage.invalid && userMessage.touched" placeholder="Nos conte sobre seu projeto..."></textarea>
            <div *ngIf="userMessage.invalid && userMessage.touched" class="invalid-feedback">Detalhes do projeto são obrigatórios.</div>
          </div>

          <div class="text-left mt-4">
            <button type="submit" class="btn btn-outline btn-md btn-circle btn-animate"
              [disabled]="contactForm.invalid">
              <span>Enviar Mensagem <i class="ion-android-arrow-forward"></i></span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</section>
<a href="https://wa.me/5538998413096?text=Olá!%20Vi%20seu%20site%20e%20gostaria%20de%20mais%20informações." 
   class="whatsapp-float" 
   target="_blank" 
   rel="noopener noreferrer">
   
   <i class="fa fa-whatsapp"></i>

</a>